import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import dynamic from "next/dynamic";
import Loading from "~/components/site/Loading";

import { showAppMessage } from "../../redux/actions/app";
import {
  fetchWordingTemplates,
  createWordingTemplateAction,
  updateWordingTemplateAction,
  setWordingTemplateModalParams,
  wordingTemplateChanged,
} from "redux/actions/wording";

import { FORM_LAYOUT, onInputChange } from "~/utils/form";
import { Button, Form, Input, Select } from "antd";
import BaseModal from "./BaseModal";
import { wordingScenariosMap } from "~/utils/wording_template";

const Editor = dynamic({
  loader: () => import("~/components/forms/Editor"),
  loading: () => <Loading />,
  ssr: false,
});

const { Option } = Select;

const Modal = ({
  token,
  isOpen,
  hideModal,
  showAppMessage,
  createWordingTemplateAction,
  updateWordingTemplateAction,
  wordingTemplateModalParams,
  setWordingTemplateModalParams,
  wordingTemplateChanged,
}: any) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [wordingTemplate, setWordingTemplate] = useState<any>({});

  const handleInputChange = onInputChange({
    state: wordingTemplate,
    setState: setWordingTemplate,
    form,
  });

  const handleContentChange = (value: any) => {
    setWordingTemplate({
      ...wordingTemplate,
      content: value.html,
      content_raw: value.text,
    });
    form.setFieldValue("content_raw", value.text);
    form.validateFields(["content_raw"]);
  };

  const handleScenariosChange = (value: any) => {
    setWordingTemplate({
      ...wordingTemplate,
      scenarios: value,
    });
  };
  const handleSubmit = () => {
    setSubmitting(true);

    const callback = (action: string) => {
      hideModal();
      setSubmitting(false);
      wordingTemplateChanged(action);
      setWordingTemplateModalParams({
        action: "create",
        wordingTemplate: {},
      });
      form.resetFields();
    };

    try {
      if (wordingTemplateModalParams.action === "create") {
        createWordingTemplateAction(token, wordingTemplate, () =>
          callback("create")
        );
      } else {
        updateWordingTemplateAction(
          token,
          {
            id: wordingTemplate.id,
            ...wordingTemplate,
          },
          () => callback("update")
        );
      }
    } catch (error) {
      setSubmitting(false);
      showAppMessage({
        message: error.message,
        type: "error",
      });
    }
  };
  useEffect(() => {
    if (
      wordingTemplateModalParams &&
      wordingTemplateModalParams.action === "update"
    ) {
      setWordingTemplate(wordingTemplateModalParams.wordingTemplate);
      form.setFieldsValue(wordingTemplateModalParams.wordingTemplate);
    } else {
      setWordingTemplate({});
      form.resetFields();
    }
  }, [wordingTemplateModalParams, form]);

  const handleCancel = () => {
    hideModal();
    setWordingTemplateModalParams({
      action: "create",
      wordingTemplate: {},
    });
    form.resetFields();
  };

  return (
    <BaseModal
      className="wording-template-modal"
      isOpen={isOpen}
      hideModal={handleCancel}
      showLogo={false}
      title={
        wordingTemplateModalParams.action === "create"
          ? "创建话术模板"
          : "编辑话术模板"
      }
    >
      <Form
        {...FORM_LAYOUT}
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          is_active: true,
        }}
      >
        <Form.Item
          name="title"
          label="模板名称"
          rules={[{ required: true, message: "请输入模板名称" }]}
        >
          <Input
            name="title"
            placeholder="请输入模板名称"
            onChange={handleInputChange}
            value={wordingTemplate.title}
          />
        </Form.Item>

        <Form.Item
          name="scenarios"
          label="模板类型"
          rules={[{ required: true, message: "请选择场景" }]}
        >
          <Select
            placeholder="请选择场景"
            mode="multiple"
            value={wordingTemplate.scenarios}
            onChange={handleScenariosChange}
          >
            {Object.entries(wordingScenariosMap).map(([key, label]) => (
              <Option
                key={key}
                value={key}
              >
                {label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="content_raw"
          label="模板内容"
          rules={[{ required: true, message: "请输入模板内容" }]}
        >
          <Editor
            name="content_raw"
            defaultValue={wordingTemplate.content_raw}
            value={wordingTemplate.content_raw}
            token={token}
            onChange={handleContentChange}
            title={wordingTemplate.title}
          />
        </Form.Item>

        <Form.Item>
          <div className="buttons-container">
            <Button onClick={handleCancel}>取消</Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
            >
              {submitting ? "保存中..." : "保存"}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </BaseModal>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.user.token,
  wordingTemplateModalParams: state.wording.wordingTemplateModalParams,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showAppMessage,
      createWordingTemplateAction,
      updateWordingTemplateAction,
      fetchWordingTemplates,
      setWordingTemplateModalParams,
      wordingTemplateChanged,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
